import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { DollarSign, Shield, Star, Ticket, Check } from 'lucide-react';
export function Slide8_Investment() {
  const buildPoints = ['Company and opportunity profiling', 'Custom ATS, dashboards, and job board integrations', 'Culture video and ad copywriting', 'Landing pages and application flows', 'End-to-end funnel, from ad to onboarding', 'Regional comp and role benchmarking', 'Pre-launch system stress test', 'Team training and 90-day coaching to optimize output'];
  const systemPoints = ['Active ad campaign management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Data-driven candidate scoring and handoff', 'Monthly executive recruiting review', 'Ongoing consulting and campaign performance enhancement'];
  const salesSchoolPoints = ['Sales School tickets are purchased separately', 'Summit: $125 per ticket', 'Advantage: $150 per ticket', 'Edge: $200 per ticket', '$5,000 monthly maximum on all packages'];
  return <SlideLayout data-id="element-393" data-mp="9md4ae56u6dq">
      <div className="flex flex-col h-full justify-center space-y-8 sm:space-y-10" data-id="element-394" data-mp="9oz9i74lw9ss">
        <div className="space-y-4 text-center" data-id="element-395" data-mp="3s0ciszi7g3ud">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-396" data-mp="3w27ijzkhm961">
            Partnership Structure
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-397" data-mp="3i2evce866b2t">
            Pricing reflects ownership and accountability, not effort or hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto w-full" data-id="element-398" data-mp="3929ruf63jwtx">
          {/* Build */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-399" data-mp="3d3231dyj4bsu">
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 flex-1" data-id="element-400" data-mp="2k9f8r9ragp91">
              <div className="w-11 h-11 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-401" data-mp="2f9sx34r3zh2c">
                <Shield className="w-5 h-5 text-[#7FE0C3]" data-id="element-402" data-mp="2b90ma72l943y" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-403" data-mp="26afm27nc6kfi">
                Build and Implementation
              </h3>
              <p className="text-slate-400 text-xs mb-5" data-id="element-404" data-mp="32yvce5y9sxto">One-time setup</p>
              <ul className="space-y-2.5" data-id="element-405" data-mp="2yz4i3s9jbzke">
                {buildPoints.map((point, i) => <li key={i} className="flex items-start" data-id="element-406" data-mp="2u6bbszyf4j67" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2.5 mt-0.5 shrink-0" data-id="element-407" data-mp="2p89r6alcgbsm" />
                    <span className="text-slate-300 text-sm leading-snug" data-id="element-408" data-mp="2p6fgdp3se029">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* System */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-409" data-mp="3p9djywoqvq7h">
            <div className="bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-6 relative flex-1" data-id="element-410" data-mp="740jf8uysetz">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-411" data-mp="c10nje8977ig" />
              <div className="w-11 h-11 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mb-4 border border-[#7FE0C3]/20" data-id="element-412" data-mp="gzbwznumzg05">
                <DollarSign className="w-5 h-5 text-[#7FE0C3]" data-id="element-413" data-mp="ltpovga3b502" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-414" data-mp="qsj175dn4pyn">System</h3>
              <p className="text-[#7FE0C3] text-xs mb-5" data-id="element-415" data-mp="utct09u7eowt">Monthly recurring</p>
              <ul className="space-y-2.5 mb-5" data-id="element-416" data-mp="zqcz2kr1zrnx">
                {systemPoints.map((point, i) => <li key={i} className="flex items-start" data-id="element-417" data-mp="m3mbx2j8si2v" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2.5 mt-0.5 shrink-0" data-id="element-418" data-mp="i2skw0ai6n5r" />
                    <span className="text-slate-300 text-sm leading-snug" data-id="element-419" data-mp="i0pu3e1j0pzz">
                      {point}
                    </span>
                  </li>)}
              </ul>
              <div className="flex items-center justify-center px-4 py-2.5 rounded-full bg-amber-500/10 border border-amber-500/30" data-id="element-420" data-mp="qx79wuku5c22">
                <Star className="w-4 h-4 text-amber-400 mr-2 shrink-0" fill="currentColor" data-id="element-421" data-mp="3v9lyplhv8ipu" />
                <span className="text-amber-400 font-medium text-sm" data-id="element-422" data-mp="d5akwzegri9w">
                  Month-to-Month Agreement
                </span>
              </div>
            </div>
          </motion.div>

          {/* Sales School Tickets */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-423" data-mp="1okphw36oaa50">
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 flex-1" data-id="element-424" data-mp="2sgq84hsaf5gi">
              <div className="w-11 h-11 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-425" data-mp="2xftce00g17nf">
                <Ticket className="w-5 h-5 text-amber-400" data-id="element-426" data-mp="3l55i2pwkaxkz" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-427" data-mp="3p6r4p2yweq8d">
                Sales School Tickets
              </h3>
              <p className="text-slate-400 text-xs mb-5" data-id="element-428" data-mp="3bgdu0sumgxfc">Purchased separately</p>
              <ul className="space-y-2.5" data-id="element-429" data-mp="3gefffkfit8tz">
                {salesSchoolPoints.map((point, i) => <li key={i} className="flex items-start" data-id="element-430" data-mp="7z5cyb7py1lo" data-mpi={i}>
                    <Check className="w-4 h-4 text-amber-400 mr-2.5 mt-0.5 shrink-0" data-id="element-431" data-mp="7wsp5hfa4x0p" />
                    <span className="text-slate-300 text-sm leading-snug" data-id="element-432" data-mp="cr5da4rpawis">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        <div className="p-5 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-433" data-mp="cn4tsi292qar">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-434" data-mp="7ok2x98w1iyz">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </div>
    </SlideLayout>;
}